import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicButton from '../../Components/Button_Basic';
import Dialog from '../../Services/Common/Dialog';
import DatePicker from '../../Components/Datepicker_Basic';
import FormGroup from '../../Components/Form_Group';
import CardH3 from '../../Components/Card_H3';
import InputBasic from '../../Components/Input_Basic';
import GridModal from '../../Components/Modal_Grid';
import AgDatePicker from '../../Components/agGrid/ag-DatePicker';
import BasicModal from '../../Components/Modal_Basic';
import Checking from '../../Components/Checking';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import BasicCombo from '../../Components/Combo_Basic';
import Commons from '../../Services/Common/Common';
function ST10030(props) {
    React.useEffect(() => {
        document.title = '재고현황';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '재고관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>재고현황</strong>" +
            '</h1>';
    }, []);
    const [modalToggle1, setModalToggle1] = React.useState(false);
    const [modalToggle2, setModalToggle2] = React.useState(false);
    const AuthGroupSettingClicked1 = (_data) => {
        setModalToggle1(true);
    };
    const AuthGroupSettingClicked2 = (_data) => {
        setModalToggle2(true);
    };
    const [selectedModalData1, setSelectedModalData1] = React.useState(null);
    const [selectedModalData2, setSelectedModalData2] = React.useState(null);
    const gridRef1 = React.useRef();
    const AuthGroupGridColumnDef1 = [
        {
            field: 'plantNm',
            headerName: '사업장명',
            minWidth: 150,
            minWidth: 100,
            cellRenderer: Commons.CustomPlantRenderer,
        },
        {
            field: 'whNm',
            headerName: '창고명',
            minWidth: 150,
        },
        {
            field: 'itemNm',
            headerName: '품목명',
            minWidth: 300,
        },
        {
            field: 'itemUnitNm',
            headerName: '품목단위',
            minWidth: 100,
        },
        {
            field: 'itemStd',
            headerName: '규격',
            editable: true,
        },
        {
            field: 'itemFormula',
            headerName: '계산식',
            hide: true,
        },
        {
            field: 'itemStdAmt',
            headerName: '단가',
            editable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(0)
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'itemCd',
            headerName: '품목코드',
        },
    ];
    const gridRef = React.useRef();
    const columnDefs = [
        //사업장
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '',
            cellRenderer: (e) => {
                return !e.data ? <span>{'TOTAL'}</span> : e.data.plantNm;
            },
            minWidth: 100,
            cellRenderer: Commons.CustomPlantRenderer,
        },
        //창고
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 300,
        },
        //규격
        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //품목타입
        {
            field: 'itemType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemTypeNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //발주수량
        {
            field: 'stockAddQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },

            cellRenderer: Commons.CustomNumberRenderer,
            aggFunc: 'sum',
            minWidth: 100,
        },
        //재고수량(BOM)
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Calculate_Qty' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellRenderer: Commons.CustomNumberRenderer,
            minWidth: 140,
        },

        //단위
        {
            field: 'itemUnit',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 100,
        },
        //품목단가
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemCost' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            // aggFunc: "sum",
            minWidth: 100,
        },
        //금액
        {
            field: 'soItemAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            minWidth: 100,
        },
        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 150,
        },

        //대분류
        {
            field: 'lCatego',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Lcategory' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //중분류
        {
            field: 'mCatego',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Mcategory' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //소분류
        {
            field: 'sCatego',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Scategory' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //품목그룹
        {
            field: 'itemGroup',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemGroupNm' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
        },
        //품목카테고리
        {
            field: 'itemCatego',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCategory' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 130,
        },
        //프로젝트명
        {
            field: 'projectNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProjectNm' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 150,
        },
        //담당자
        {
            field: 'personCharg',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PersonCharg' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
        },
        //비고
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 150,
        },
        // //LOT_NO
        // {
        //   field: "lotNo",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_LotNo" && f.lanType === "COL"
        //         )[0].lanName
        //       : "",
        //   minWidth: 110,
        // },
        // //재고조사일
        // {
        //   field: "stockTakingDt",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_StockTakingDate" && f.lanType === "COL"
        //         )[0].lanName
        //       : "",
        //   minWidth: 110,
        // },
        //제조일자
        {
            field: 'manuFacDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ManufacturingDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //불출가능여부
        {
            field: 'doYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DoYn' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
            cellStyle: { textAlign: 'center' },
        },
        //등록일
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //등록자
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //수정일
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //수정자
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        }, //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
    ];
    const lotColumnDef = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 60,
            valueGetter: 'node.rowIndex + 1',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            cellStyle: { textAlign: 'right' },
        },
        //LOT No
        {
            field: 'lotNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LotNo' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 250,
        },
        //수량
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        //창고
        {
            field: 'whCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
    ];
    const onCellClicked = (e) => {
        const selected = e.data;
    };
    const [modalToggle, setModalToggle] = React.useState(false);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '100%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    ></div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {/* 재고이동 */}
                        <BasicButton
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_MoveStock' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : ''
                            }
                            onClick={(e) => {
                                AuthGroupSettingClicked2(e);
                                props.setStockData([]);
                            }}
                        />
                        <AuthGroupButton
                            pageName="ST10030"
                            target="G01"
                            refreshNone="none"
                            selectFunc={() => {
                                props.SearchLogic();
                            }}
                            addFunc={() => setModalToggle(true)}
                        />
                    </div>
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        // groupIncludeTotalFooter={true}
                        groupIncludeFooter={true}
                        groupIncludeTotalFooter={true}
                        defaultColDef={{
                            flex: 1,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        rowData={props.rowData}
                        rowSelection="multiple"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                        onCellClicked={onCellClicked}
                        suppressRowClickSelection={true}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        groupDefaultExpanded={1}
                        suppressAggFuncInHeader={true}
                        enableCellChangeFlash={true}
                        getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : '')}
                    />
                </div>
                {modalToggle && (
                    <BasicModal
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter(
                                      (f) => f.lanId === 'Fom_InventoryGeneration' && f.lanType === 'FORM'
                                  )[0].lanName
                                : ''
                        }
                        onClose={() => setModalToggle(false)}
                        buttonName1={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                                : ''
                        }
                        execLogic={() => {
                            props.StockHelper();
                        }}
                    >
                        <FormGroup
                            columnCount={2}
                            datas={[
                                // {
                                //   type: "combo",
                                //   name: "품목코드",
                                //   value: props.checkInputs.itemCd,
                                //   combos: props.itemType,
                                //   onChange: (e) => {
                                //     let plantCd1 = props.itemType.filter((f) => f.value === e);
                                //     props.setCheckInputs({
                                //       ...props.checkInputs,
                                //       itemCd: e,
                                //       plantCd: plantCd1[0].plantCd,
                                //     });
                                //   },
                                // },
                                //품목코드
                                {
                                    type: 'button',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_ItemCd' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '',
                                    btnName:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Btn_Setting' && f.lanType === 'BTN'
                                              )[0].lanName
                                            : '',
                                    onClick: (e) => {
                                        AuthGroupSettingClicked1(e);
                                    },
                                },
                                //품목명
                                {
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_ItemNm' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '',
                                    value: props.checkInputs.itemNm,
                                    onChange: (e) => {
                                        props.setCheckInputs({
                                            ...props.checkInputs,
                                            itemNm: e.target.value,
                                        });
                                    },
                                    readOnly: true,
                                },
                                // //품목단위
                                // {
                                //   name:
                                //     props.lanData.length > 0
                                //       ? props.lanData.filter(
                                //           (f) =>
                                //             f.lanId === "Fom_ItemUnit" && f.lanType === "FORM"
                                //         )[0].lanName
                                //       : "",
                                //   value: props.checkInputs.itemUnitNm,
                                //   onChange: (e) => {
                                //     console.log(e);
                                //     props.setCheckInputs({
                                //       ...props.checkInputs,
                                //       itemUnitNm: e.target.value,
                                //     });
                                //   },
                                //   readOnly: true,
                                // },
                                //추가수량
                                {
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_AdditionalQuantity' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '',
                                    value: props.checkInputs.itemQty,
                                    inputType: 'number',
                                    onChange: (e) => {
                                        props.setCheckInputs({
                                            ...props.checkInputs,
                                            itemQty: e.target.value,
                                        });
                                    },
                                },
                                //창고
                                {
                                    type: 'combo',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_WhNm' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '',
                                    value: props.checkInputs.whCd,
                                    combos: props.whType,
                                    onChange: (e) => {
                                        props.setCheckInputs({
                                            ...props.checkInputs,
                                            whCd: e,
                                        });
                                    },
                                },
                            ]}
                        />
                    </BasicModal>
                )}
                {modalToggle1 && (
                    <GridModal
                        //품목타입
                        conditions={[
                            {
                                type: 'combo',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_ItemTypeNm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '',
                                combos: props.checkInputs.comboList,
                                value: props.checkInputs1.itemType,
                                onChange: (e) => {
                                    props.setCheckInputs1({
                                        ...props.checkInputs1,
                                        itemType: e,
                                    });
                                },
                            },
                            //품목코드/명
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_ItemCd/Nm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '',
                                value: props.checkInputs1.value1,
                                onChange: (e) => {
                                    props.setCheckInputs1({
                                        ...props.checkInputs1,
                                        value1: e.target.value,
                                    });
                                },
                                onClick: (e) => {
                                    // document.getElementsByName("품목코드/명").focus;
                                },
                                onKeyDown: (e) => {
                                    props.GetCommonItemList(props.checkInputs1.value1);
                                },
                            },
                            {
                                type: 'button',
                                style: {
                                    width: '100px',
                                },
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN'
                                          )[0].lanName
                                        : '',
                                onClick: (e) => {
                                    props.GetCommonItemList(props.checkInputs1.value1);
                                },
                            },
                        ]}
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Fom_ItemCd/Nm' && f.lanType === 'FORM')[0]
                                      .lanName
                                : ''
                        }
                        onClose={() => setModalToggle1(false)}
                        gridColumn={AuthGroupGridColumnDef1}
                        gridRowData={props.authGroupGridRowData1}
                        buttonName1={
                            props.lanData.length > 0
                                ? props.lanData.filter(
                                      (f) => f.lanId === 'Fom_ItemCdSetting' && f.lanType === 'FORM'
                                  )[0].lanName
                                : ''
                        }
                        onCellValueChanged={(e) => {
                            GridFunctions.onCellValueChanged(e, AuthGroupGridColumnDef1, props.setChangedRowData1);
                        }}
                        gridOnClick={(e) => {
                            let data = [];
                            for (let i = 0; i < e.length; i++) {
                                data.push({
                                    plantCd: e[i].plantCd,
                                    itemCd: e[i].itemCd,
                                    itemNm: e[i].itemNm,
                                    itemStd: e[i].itemStd,
                                    itemUnit: e[i].itemUnit,
                                    itemUnitNm: e[i].itemUnitNm,
                                    itemStdAmt: e[i].itemStdAmt,
                                    poItemCost: e[i].poItemCost,
                                    itemVatYn: e[i].itemVatYn,
                                    itemFormula: e[i].itemFormula,
                                    itemUnitNm: e[i].itemUnitNm,
                                });
                            }
                            setSelectedModalData1(data);
                        }}
                        gridOnDoubleClick={(e) => false}
                        execLogic={(e) => {
                            props.setCheckInputs({
                                ...props.checkInputs,
                                itemCd: selectedModalData1[0].itemCd,
                                itemNm: selectedModalData1[0].itemNm,
                                plantCd: selectedModalData1[0].plantCd,
                                itemUnitNm: selectedModalData1[0].itemUnitNm,
                            });
                        }}
                    />
                )}
                {/* 재고 이동 */}
                {modalToggle2 && (
                    <GridModal
                        conditions={[
                            //품목코드/명
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_ItemCd/Nm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '',
                                value: props.checkInputs2.value1,
                                onChange: (e) => {
                                    props.setCheckInputs2({
                                        ...props.checkInputs2,
                                        value1: e.target.value,
                                    });
                                },
                                onClick: (e) => {
                                    // document.getElementsByName("품목코드/명").focus;
                                },
                                onKeyDown: (e) => {
                                    props.GetMoveStockData(props.checkInputs2.value1, props.checkInputs2.whCd);
                                },
                            },
                            //창고(조회)
                            {
                                type: 'comboInput',
                                name: '조회 창고',
                                combos: props.checkInputs.comboWhCd,
                                value: props.checkInputs2.whCd,
                                onChange: (e) => {
                                    props.setCheckInputs2({
                                        ...props.checkInputs2,
                                        whCd: e,
                                    });
                                },
                            },
                            // 창고(조회)
                            {
                                type: 'button',
                                style: {
                                    width: '100px',
                                },
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN'
                                          )[0].lanName
                                        : '',
                                onClick: (e) => {
                                    props.GetMoveStockData(props.checkInputs2.value1, props.checkInputs2.whCd);
                                },
                            },
                            // 이동할 창고
                            {
                                type: 'comboInput',
                                name: '이동 창고',

                                // name:
                                //   props.lanData.length > 0
                                //     ? props.lanData.filter(
                                //         (f) =>
                                //           f.lanId === "Fom_ItemTypeNm" && f.lanType === "FORM"
                                //       )[0].lanName
                                //     : "",
                                combos: props.checkInputs.comboMoveWhCd,
                                value: props.checkInputs2.moveWhCd,
                                onChange: (e) => {
                                    props.setCheckInputs2({
                                        ...props.checkInputs2,
                                        moveWhCd: e,
                                    });
                                },
                            },
                        ]}
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Fom_ItemCd/Nm' && f.lanType === 'FORM')[0]
                                      .lanName
                                : ''
                        }
                        onClose={() => setModalToggle2(false)}
                        gridColumn={lotColumnDef}
                        gridRowData={props.stockData}
                        buttonName1={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Fom_MoveStock' && f.lanType === 'FORM')[0]
                                      .lanName
                                : ''
                        }
                        gridOnClick={(e) => {
                            let data = [];
                            for (let i = 0; i < e.length; i++) {
                                data.push({
                                    plantCd: e[i].plantCd,
                                    lotNo: e[i].lotNo,
                                    itemCd: e[i].itemCd,
                                    whCd: e[i].whCd,
                                });
                            }
                            setSelectedModalData2(data);
                        }}
                        execLogic={(e) => {
                            props.SaveConfirm(selectedModalData2);
                            // props.GetMoveStockData(
                            //   props.checkInputs2.value1,
                            //   props.checkInputs2.whCd
                            // );
                        }}
                    />
                )}
            </div>
        </div>
    );
}

export default ST10030;
